import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { State } from "../../../domain/model/ResponseState";
import { GetAllStoresUseCase } from "../../../domain/usecase/store/getAll/GetAllUseCase";
import { Store } from "../../../domain/model/Store";
import { GetPerStoreReportUseCase } from "../../../domain/usecase/report/getPerStore/UseCase";
import { downloadBlob, showGlobalLoadingView } from "../../../core/utils/Utils";

export function StoresViewModel(
  getAllStoresUseCase: GetAllStoresUseCase,
  getPerStoreReportUseCase: GetPerStoreReportUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);

  const [stores, setStores] = useState<Array<Store> | undefined>();

  useEffect(() => {
    fetchStores();
  }, []);

  async function fetchStores() {
    setLoading(true);
    const response = await getAllStoresUseCase.invoke();
    switch (response.responseState) {
      case State.Success:
        setStores(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
  }

  async function getPerStoreReport() {
    showGlobalLoadingView(true);
    const response = await getPerStoreReportUseCase.invoke();
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        downloadBlob(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return { stores, isLoading, setLoading, getPerStoreReport };
}
